import {Formik} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {Pipeline, PipelineRecordFormProps} from '../types';
import {stage} from "../../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: PipelineRecordFormProps) => {

    // Returns the mutation's promise so Formik keeps `isSubmitting` true until
    // the server has actually answered — that is what disables the submit
    // button, and what lets the drawer wait before closing.
    const onSubmit = async (values: Pipeline) => {
        return await handleSubmit(values);
    };

    let initialValues = {} as Pipeline;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
